<div class="row">&nbsp;</div>
<div class="lm-flex-row-responsive-container">
  <div class="five columns">
    <ng-container [ngTemplateOutlet]="DATAGRID"></ng-container>
  </div>
  @if (selectedRow) {
    <div class="seven columns">
      <ng-container [ngTemplateOutlet]="DETAIL"></ng-container>
    </div>
  }
</div>

<ng-template #DATAGRID>
  <!-- List-level Options -->
  <div class="row form-layout-compact">
    <div class="field">
      <input
        type="checkbox"
        soho-checkbox
        data-automation-id="lm-personalization-restrict-open-action"
        id="lm-personalization-restrict-open-action"
        name="lm-personalization-restrict-open-action"
        [(ngModel)]="restrictOpenAction"
        (change)="restrictOpenActionChange.emit(restrictOpenAction)"
        />
        <label
          soho-label
          for="lm-personalization-restrict-open-action"
          [forCheckBox]="true"
          >{{ "RestrictedActions_RestrictOpenAction" | translate }}
        </label>
      </div>
    </div>
    <!-- Restricted Actions Toolbar-->
    <soho-toolbar-flex noActionsButton="true" hasMoreButton="false">
      <soho-toolbar-title></soho-toolbar-title>
      <soho-toolbar-flex-section>
        <button
          data-automation-id="lm-personalization-restrict-action-btn"
          id="restrict-item"
          type="button"
          soho-button="btn"
          icon="add"
          (click)="onAddAction()"
          >
          {{ "RestrictedActions_AddButton" | translate }}
        </button>

        <button
          data-automation-id="lm-personalization-delete-action-btn"
          id="delete-item"
          soho-button="icon"
          icon="delete"
          [disabled]="!selectedAction"
          (click)="onRemoveAction()"
          >
          {{ "ListPersonalizationRemoveButtonLabel" | translate }}
        </button>
      </soho-toolbar-flex-section>
    </soho-toolbar-flex>

    <!-- Restricted Actions Data Grid-->
    @if (actionGridOptions) {
      <div
        style="height: 450px"
        class="scrollable-flex-content"
        data-automation-id="lm-personalization-action-data-grid"
        soho-datagrid
        #actionDataGridComponent
        [attr.id]="actionDataGridComponent"
        [gridOptions]="actionGridOptions"
        (rowClicked)="onRowClicked($event)"
      ></div>
    }
  </ng-template>

  <ng-template #DETAIL>
    @if (selectedAction) {
      <span class="text-secondary lm-bold font-size-md">{{
        "ColumnEditorFieldDetailsLabel" | translate
      }}</span>
      <div class="row top-padding">
        <div class="field">
          <label soho-label for="lm-personalization-restricted-actions-label"
            >{{ "ColumnEditorLabelLabel" | translate }}
          </label>
          <p
            id="lm-personalization-restricted-actions-label"
            data-automation-id="lm-personalization-restricted-actions-label"
            class="hide-white-space lm-text-data"
            ngClass="text-default"
            >
            {{ selectedAction?.label }}
          </p>
        </div>
      </div>
      <div class="row form-layout-compact compound-field">
        <div class="field">
          <label soho-label for="lm-personalization-restricted-when">
            {{ "RestrictedActions_RestrictedWhenLabel" | translate }}
          </label>
          <input
            type="text"
            data-automation-id="lm-personalization-restricted-when"
            id="lm-personalization-restricted-when"
            name="lm-personalization-restricted-when"
            [(ngModel)]="selectedAction.condition"
            soho-alert
            soho-lookup
            [click]="onGetConditionQualifier"
            soho-busyindicator
            blockUI="true"
            displayDelay="0"
            (change)="validateCondition()"
            />
          </div>
          <div class="field">
            <input
              type="checkbox"
              soho-checkbox
              data-automation-id="lm-personalization-restricted-when-negated"
              id="lm-personalization-restricted-when-negated"
              name="lm-personalization-restricted-when-negated"
              [disabled]="!selectedAction.condition"
              [(ngModel)]="selectedAction.negated"
              (change)="onDetailChange()"
              />
              <label
                soho-label
                for="lm-personalization-restricted-when-negated"
                [forCheckBox]="true"
                >{{ "ColumnEditorAlertNegatedLabel" | translate }}
              </label>
            </div>
          </div>
        }
      </ng-template>
